import React from 'react';

import PropTypes from 'prop-types';

import ComplexPopup from 'apps/auth/components/common/Popup/ComplexPopup';
import { ComplexPopupRow } from 'apps/auth/components/common/Popup/styles';
import { useExtra, usePageMessages } from 'apps/auth/hooks/selectors';

import CountryPanelForAccount from './CountryPanelForAccount';

const ChangeLinkedAccPopup = (props) => {
    const { linkYourCard } = usePageMessages();
    const { accounts = [] } = useExtra();
    return (
        <ComplexPopup withoutButton textCenter popupRef={props.popupRef}>
            <ComplexPopupRow>{linkYourCard}</ComplexPopupRow>
            {accounts.map((account, i) => (
                <CountryPanelForAccount
                    key={account + i}
                    account={account}
                    doRequest={props.doRequest}
                    popupRef={props.popupRef}
                    getCurrencyIcon={props.getCurrencyIcon}
                    onError={props.onError}
                />
            ))}
        </ComplexPopup>
    );
};
ChangeLinkedAccPopup.propTypes = {
    popupRef: PropTypes.shape({ current: PropTypes.object }).isRequired,
};
export default ChangeLinkedAccPopup;
